import styled from 'styled-components';

import {FullWidthSpace} from '@custom-antd';

export const StyledFormSpace = styled(FullWidthSpace)`
  .ant-form-item-control-input-content {
    display: flex;
    justify-content: flex-end;
  }
`;

export const TestCreationModalWrapper = styled.div`
  display: flex;
`;
